/**
 * @fileoverview gRPC-Web generated client stub for tradepb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.tradepb = require('./modeling_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.tradepb.ModelingServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.tradepb.ModelingServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tradepb.ListModelingRequest,
 *   !proto.tradepb.ListModelingResponse>}
 */
const methodDescriptor_ModelingService_ListModeling = new grpc.web.MethodDescriptor(
  '/tradepb.ModelingService/ListModeling',
  grpc.web.MethodType.UNARY,
  proto.tradepb.ListModelingRequest,
  proto.tradepb.ListModelingResponse,
  /**
   * @param {!proto.tradepb.ListModelingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tradepb.ListModelingResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.tradepb.ListModelingRequest,
 *   !proto.tradepb.ListModelingResponse>}
 */
const methodInfo_ModelingService_ListModeling = new grpc.web.AbstractClientBase.MethodInfo(
  proto.tradepb.ListModelingResponse,
  /**
   * @param {!proto.tradepb.ListModelingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tradepb.ListModelingResponse.deserializeBinary
);


/**
 * @param {!proto.tradepb.ListModelingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.tradepb.ListModelingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tradepb.ListModelingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tradepb.ModelingServiceClient.prototype.listModeling =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tradepb.ModelingService/ListModeling',
      request,
      metadata || {},
      methodDescriptor_ModelingService_ListModeling,
      callback);
};


/**
 * @param {!proto.tradepb.ListModelingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tradepb.ListModelingResponse>}
 *     A native promise that resolves to the response
 */
proto.tradepb.ModelingServicePromiseClient.prototype.listModeling =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tradepb.ModelingService/ListModeling',
      request,
      metadata || {},
      methodDescriptor_ModelingService_ListModeling);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tradepb.CreateTradeSheetRequest,
 *   !proto.tradepb.EmptyResponse>}
 */
const methodDescriptor_ModelingService_CreateTradeSheet = new grpc.web.MethodDescriptor(
  '/tradepb.ModelingService/CreateTradeSheet',
  grpc.web.MethodType.UNARY,
  proto.tradepb.CreateTradeSheetRequest,
  proto.tradepb.EmptyResponse,
  /**
   * @param {!proto.tradepb.CreateTradeSheetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tradepb.EmptyResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.tradepb.CreateTradeSheetRequest,
 *   !proto.tradepb.EmptyResponse>}
 */
const methodInfo_ModelingService_CreateTradeSheet = new grpc.web.AbstractClientBase.MethodInfo(
  proto.tradepb.EmptyResponse,
  /**
   * @param {!proto.tradepb.CreateTradeSheetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tradepb.EmptyResponse.deserializeBinary
);


/**
 * @param {!proto.tradepb.CreateTradeSheetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.tradepb.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tradepb.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tradepb.ModelingServiceClient.prototype.createTradeSheet =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tradepb.ModelingService/CreateTradeSheet',
      request,
      metadata || {},
      methodDescriptor_ModelingService_CreateTradeSheet,
      callback);
};


/**
 * @param {!proto.tradepb.CreateTradeSheetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tradepb.EmptyResponse>}
 *     A native promise that resolves to the response
 */
proto.tradepb.ModelingServicePromiseClient.prototype.createTradeSheet =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tradepb.ModelingService/CreateTradeSheet',
      request,
      metadata || {},
      methodDescriptor_ModelingService_CreateTradeSheet);
};


module.exports = proto.tradepb;

